import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIでクラウド利用ライセンスコードの登録が成功した場合に呼び出されます
   * @callback success
   * @param {number} status - httpステータス
   */
  success: (status: number) => void;
}

export interface IRegistTermRequesuModel {
  /**
   * クラウド利用ライセンスコード
   */
  termcode: string;
}

function AxiosPost(
  url: string,
  params: IRegistTermRequesuModel,
  token?: string
) {
  if (token) {
    return axios.post(url, JSON.stringify(params), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.post(url, JSON.stringify(params), {
      headers: { "Content-Type": "application/json" },
    });
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
    .then((res) => {
      params.success(res.status);
    })
    .catch((err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    });
}

export interface IRegistTermParams
  extends IRegistTermRequesuModel,
    ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
}

/**
 * クラウド利用ライセンスコードを登録します
 * @function registTerm
 * @param {IRegistTermParams} params - クラウド利用ライセンスコード登録パラメータ
 */
export function registTerm(params: IRegistTermParams): void {
  const { authService, termcode } = params;
  const req: IRegistTermRequesuModel = {
    termcode: termcode,
  };
  const url = WebAPI.REGIST_TERM;
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosPost(url, req, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              registTermRetry401(authService, url, req, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      },
      fail: (err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosPost(url, req),
      success: params.success,
      fail: params.fail,
    });
  }
}

/**
 * クラウド利用ライセンスコードを登録します
 * @function registTermRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {IRegistTermRequesuModel} req - リクエストパラメータ
 * @param {ICallbackParams} params - コールバックパラメータ
 */
function registTermRetry401(
  authService: AuthService,
  url: string,
  req: IRegistTermRequesuModel,
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosPost(url, req, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}
